/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum BrokernetFileMimeType {
    Sonstiges = 'Sonstiges',
    Pdf = 'Pdf',
    Doc = 'Doc',
    Docx = 'Docx',
    Mp4 = 'Mp4',
    Jpg = 'Jpg',
    Jpeg = 'Jpeg',
    Png = 'Png',
    Txt = 'Txt',
    Eml = 'Eml'
  }

    export const BrokernetFileMimeTypeTranslocoMap: Record<BrokernetFileMimeType, string> = {
    [BrokernetFileMimeType.Sonstiges]: 'brokernetFileMimeType.sonstiges',
    [BrokernetFileMimeType.Pdf]: 'brokernetFileMimeType.pdf',
    [BrokernetFileMimeType.Doc]: 'brokernetFileMimeType.doc',
    [BrokernetFileMimeType.Docx]: 'brokernetFileMimeType.docx',
    [BrokernetFileMimeType.Mp4]: 'brokernetFileMimeType.mp4',
    [BrokernetFileMimeType.Jpg]: 'brokernetFileMimeType.jpg',
    [BrokernetFileMimeType.Jpeg]: 'brokernetFileMimeType.jpeg',
    [BrokernetFileMimeType.Png]: 'brokernetFileMimeType.png',
    [BrokernetFileMimeType.Txt]: 'brokernetFileMimeType.txt',
    [BrokernetFileMimeType.Eml]: 'brokernetFileMimeType.eml',
    };

    export const BrokernetFileMimeTypeOptions = [
  { value: BrokernetFileMimeType.Sonstiges, labelKey: 'brokernetFileMimeType.sonstiges' },
  { value: BrokernetFileMimeType.Pdf, labelKey: 'brokernetFileMimeType.pdf' },
  { value: BrokernetFileMimeType.Doc, labelKey: 'brokernetFileMimeType.doc' },
  { value: BrokernetFileMimeType.Docx, labelKey: 'brokernetFileMimeType.docx' },
  { value: BrokernetFileMimeType.Mp4, labelKey: 'brokernetFileMimeType.mp4' },
  { value: BrokernetFileMimeType.Jpg, labelKey: 'brokernetFileMimeType.jpg' },
  { value: BrokernetFileMimeType.Jpeg, labelKey: 'brokernetFileMimeType.jpeg' },
  { value: BrokernetFileMimeType.Png, labelKey: 'brokernetFileMimeType.png' },
  { value: BrokernetFileMimeType.Txt, labelKey: 'brokernetFileMimeType.txt' },
  { value: BrokernetFileMimeType.Eml, labelKey: 'brokernetFileMimeType.eml' },
    ];

